module.exports = __webpack_public_path__ + "img/icon_map_32_off_010.a172c685.png";